module.exports = __webpack_public_path__ + "static/media/feiras.8666a293.jpg";